import 'jquery.easing';

export const scrollTop = (scrollTop) => {
    $('html, body').animate({ scrollTop }, { easing: 'easeOutExpo' });
}